import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => ( {
	dotsIcon: {
		width        : "30px",
		height       : "30px",
		cursor       : "pointer",
		background   : props?.open ? theme.other.colors.background2.primary : "",
		borderRadius : props?.pen ? "100%" : "",

		"&:hover": {
			backgroundColor : theme.other.colors.background2.primary,
			borderRadius    : "100%"
		}
	},
	svgIcon: {
		cursor : "pointer",
		width  : "30px"
	},
	iconText: {
		fontSize    : "1.5rem",
		paddingLeft : "1rem",
		cursor      : "pointer",
		fontWeight  : "500"
	},
	popperStyle: {
		padding      : "0.75rem",
		borderRadius : "5px",
		boxShadow    : theme.other.colors.boxShadow.primary
	},
	popperWrapper: {
		zIndex: "1300 !important"
	},
	menuItem: {
		display      : "flex",
		alignItems   : "center",
		padding      : "0.5rem",
		borderRadius : "5px",
		cursor       : "pointer",
		"&:hover"    : {
			backgroundColor: "rgba(0, 0, 0, 0.04)"
		}
	},
	menuItemInfoModal: {
		opacity      : "1",
		display      : "flex",
		alignItems   : "center",
		padding      : "0.5rem",
		borderRadius : "5px",
		cursor       : "pointer",
		"&:hover"    : {
			backgroundColor: "rgba(0, 0, 0, 0.04)"
		}
	},
	followComponent: {
		display      : "flex",
		alignItems   : "center",
		padding      : "0.75rem",
		borderRadius : "5px",
		"&:hover"    : {
			backgroundColor: "rgba(0, 0, 0, 0.04)"
		}
	},
	loaderWrapper: {
		// width  : "15rem",
		width   : "15rem",
		height  : "4rem",
		padding : "0 !important"
	},
	rectangularSekleton:
	{
		margin : "0 10px",
		width  : "80%"
	},
	settingsIcon: {
		height : "2.8rem",
		width  : "2.8rem"
	}
} ) );